import { AppError } from './app-error';

export class BadInput extends AppError { }


// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/bad-input.ts